import { JOBS_LIST } from './../../../constants';
import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalculateFolioSubformComponent } from './calculate-folio-subform/calculate-folio-subform.component';
import { ZoningCodeSubformComponent } from './zoning-code-subform/zoning-code-subform.component';
import { JobsService } from '../../../services/jobs.service';
import { TaskType, getPrettyTaskType, getTaskDescriptionByTaskType, ListType } from '../../../../../shared/enums';
import { InstanceService } from '../../../services/instance.service';
// import { ImportNewIdsSubformComponent } from './import-new-ids-subform/import-new-ids-subform.component';
import { RecalculateByStatusComponent } from './recalculate-by-status/recalculate-by-status.component';
import { TypologySubformComponent } from './typology-subform/typology-subform.component';
import * as _ from 'lodash';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { FileChooserSubformComponent } from './file-chooser-subform/file-chooser-subform.component';
import { getDataSourceCategoriesArr } from 'src/app/shared/enums/data-source-category';
import { DataSourceCategorySubformComponent } from './data-source-category-subform/data-source-category-subform.component';
import { ZcVersionSelectSubformComponent } from './zc-version-select-subform/zc-version-select-subform.component';
import { ZoningCodeStatus } from 'src/app/shared/enums/zoning-code-status';
import { appSettings } from 'src/settings/config';
@Component({
    standalone: false,
    selector: 'app-add-job-dialog',
    templateUrl: './add-job-dialog.component.html',
    styleUrls: ['./add-job-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddJobDialogComponent implements OnInit {
    addJobForm: FormGroup;
    selectedJobType: TaskType = null;
    taskType = TaskType;
    jobsList = JOBS_LIST;
    private addedSubForms: Array<string> = [];

    process: ITaskModel;
    isReconfiguration: boolean = false;

    getPrettyTaskType = getPrettyTaskType;
    getTaskDescriptionByTaskType = getTaskDescriptionByTaskType;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ITaskModel,
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<AddJobDialogComponent>,
        private jobsService: JobsService,
        private cdRef: ChangeDetectorRef,
        private instanceService: InstanceService,
        private readonly snackBar: MatSnackBar
    ) {
        this.process = data;
        this.isReconfiguration = !!this.process;
    }

    get showZoningCodeSubform(): boolean {
        return (
            [
                TaskType.FILL_ZC_APPLICABLE_TYPOLOGIES,
                TaskType.SYNC_ZONING_CODE_SOLR_DATA,
                TaskType.REMOVE_ZONING_CODE_SOLR_DATA,
                TaskType.REMOVE_ZONING_CODE_JOB,
                TaskType.SYNC_ZC_PRS_JOB,
                TaskType.REINDEX_MISSED_ZC_AU_JOB,
                TaskType.GET_3D_TILES_DATA,
                TaskType.GET_AUTOMATION_DATA_JOB
            ].indexOf(this.selectedJobType) >= 0
        );
    }

    get isZoningCodeOptional(): boolean {
        return [TaskType.GET_3D_TILES_DATA, TaskType.GET_AUTOMATION_DATA_JOB].indexOf(this.selectedJobType) >= 0;
    }

    get showListsSubform(): boolean {
        return (
            [
                TaskType.CALCULATE_FOLIOS,
                TaskType.CALCULATE_FOLIOS_MULTI_THREAD,
                TaskType.GET_3D_TILES_DATA,
                TaskType.GET_AUTOMATION_DATA_JOB,
                TaskType.CALCULATE_ALL_TYPOLOGIES,
                TaskType.REMOVE_PROPERTY_RECORDS
            ].indexOf(this.selectedJobType) >= 0
        );
    }

    get forcedModeDisabled(): boolean {
        return [TaskType.REMOVE_PROPERTY_RECORDS].indexOf(this.selectedJobType) >= 0;
    }

    get showTypologySubform(): boolean {
        return [TaskType.CALCULATE_ALL_TYPOLOGIES].indexOf(this.selectedJobType) >= 0;
    }

    // get showImportNewIdsSubform(): boolean {
    //     return (
    //         [TaskType.IMPORT_NEW_PR_IDS, TaskType.IMPORT_NEW_ZCV_IDS, TaskType.IMPORT_NEW_STREET_IDS].indexOf(
    //             this.selectedJobType
    //         ) >= 0
    //     );
    // }

    get showRecalculateForm(): boolean {
        return (
            [TaskType.RECALCULATE_BY_STATUS, TaskType.RECALCULATE_LISTED_BY_STATUS_JOB].indexOf(this.selectedJobType) >=
            0
        );
    }

    get showZoningCodeSettings(): boolean {
        return [TaskType.CALCULATE_FOLIOS, TaskType.CALCULATE_FOLIOS_MULTI_THREAD].indexOf(this.selectedJobType) >= 0;
    }

    get showFileChooserSubform(): boolean {
        return (
            [TaskType.REPLACE_LAND_USE_IDS, TaskType.CALCULATE_GROUP_IDS_WITH_UPDATED_PLACES_JOB].indexOf(
                this.selectedJobType
            ) >= 0
        );
    }

    get canSave(): boolean {
        return this.addJobForm.valid;
    }

    get ignoreInstanceId(): boolean {
        return (
            [
                TaskType.COLLECT_PRS_ZONING_DATA,
                TaskType.COLLECT_PRS_OVERLAYS_DATA,
                TaskType.SYNC_ZONING_CODE_SOLR_DATA,
                TaskType.REMOVE_ZONING_CODE_SOLR_DATA,
                TaskType.COLLECT_PRS_MARKET_DATA,
                TaskType.REMOVE_ZCV_CRS_JOB,
                TaskType.REMOVE_ZONING_CODE_JOB,
                TaskType.SYNC_ZC_PRS_JOB,
                TaskType.REINDEX_MISSED_ZC_AU_JOB,
                TaskType.FILL_BUILDING_MODEL_GEOMETRIES_JOB,
                TaskType.CALCULATE_GROUP_IDS_WITH_UPDATED_PLACES_JOB
            ].indexOf(this.selectedJobType) >= 0
        );
    }

    get showDataSourceCategorySubform(): boolean {
        return (
            [
                TaskType.SYNC_ZONING_CODE_SOLR_DATA,
                TaskType.REMOVE_ZONING_CODE_SOLR_DATA,
                TaskType.SYNC_ZC_PRS_JOB,
                TaskType.RECALCULATE_LISTED_BY_STATUS_JOB
            ].indexOf(this.selectedJobType) >= 0
        );
    }

    get showZoningCodeVersionSubform(): boolean {
        return [TaskType.REMOVE_ZCV_CRS_JOB].indexOf(this.selectedJobType) >= 0;
    }

    get showSyncSolrUADataCheckbox(): boolean {
        return (
            [
                TaskType.CALCULATE_FOLIOS,
                TaskType.CALCULATE_FOLIOS_MULTI_THREAD,
                TaskType.GET_3D_TILES_DATA,
                TaskType.GET_AUTOMATION_DATA_JOB,
                TaskType.CALCULATE_ALL_TYPOLOGIES,
                TaskType.RECALCULATE_BY_STATUS,
                TaskType.RECALCULATE_LISTED_BY_STATUS_JOB
                // TaskType.CALCULATE_GROUP_IDS_WITH_UPDATED_PLACES_JOB, // Use for testing
            ].indexOf(this.selectedJobType) >= 0
        );
    }

    get showSaveRawIds(): boolean {
        return [TaskType.SYNC_ZC_PRS_JOB].indexOf(this.selectedJobType) >= 0;
    }

    get showRecalculateAllPRsCheckbox(): boolean {
        return [TaskType.CALCULATE_GROUP_IDS_WITH_UPDATED_PLACES_JOB].indexOf(this.selectedJobType) >= 0;
    }

    getAllwedZCStatuses(): ZoningCodeStatus[] {
        switch (this.selectedJobType) {
            case TaskType.SYNC_ZONING_CODE_SOLR_DATA:
                return [ZoningCodeStatus.ACTIVE, ZoningCodeStatus.DRAFT];
            default:
                return null;
        }
    }

    ngOnInit() {
        this.addJobForm = this.formBuilder.group({
            name: null,
            startImmediately: true,
            syncSolrData: appSettings.allowSyncSolrAUData,
            saveRawIds: false,
            recalculateAllPRs: false
        });

        this.addJobForm.statusChanges.subscribe(() => this.cdRef.markForCheck());

        this.configureDialogWithProcess();
    }

    formInitialized(name: string, form: FormGroup) {
        setTimeout(() => {
            this.addJobForm.setControl(name, form);
            this.addedSubForms.push(name);
        }, 0);
    }

    onChange(_$event) {
        for (const subform of this.addedSubForms) {
            this.addJobForm.removeControl(subform);
            const index = this.addedSubForms.indexOf(subform);
            if (index > -1) {
                this.addedSubForms.splice(index, 1);
            }
        }
    }

    onSubmit() {
        const input = new FormData();
        input.append('name', this.addJobForm.value['name']);
        input.append('doNotRun', JSON.stringify(!this.addJobForm.value['startImmediately']));
        if (this.showSyncSolrUADataCheckbox) {
            input.append('syncSolrData', JSON.stringify(this.addJobForm.controls.syncSolrData.value));
        }
        if (this.showSaveRawIds) {
            input.append('saveRawIds', JSON.stringify(this.addJobForm.value['saveRawIds']));
        }
        if (this.showRecalculateAllPRsCheckbox) {
            input.append('recalculateAllPRs', JSON.stringify(this.addJobForm.value['recalculateAllPRs']));
        }
        const instanceId = _.get(this.instanceService, 'selectedInstance.Id', _.get(this, 'process.instanceId'));
        if (!this.ignoreInstanceId) {
            input.append('instanceId', JSON.stringify(instanceId));
        }

        if (this.showListsSubform) {
            this.appendListSubformData(input);
        }

        if (this.showTypologySubform) {
            this.appendTypologySubformData(input);
        } else if (this.showZoningCodeSubform) {
            this.appendZoningCodeSubformData(input);
            // } else if (this.showImportNewIdsSubform) {
            //     this.appendImportNewIdsSubformData(input);
        } else if (this.showRecalculateForm) {
            this.appendZoningCodeDropDownData(input);
        }

        if (this.showFileChooserSubform) {
            this.appendFileChooserSubformData(input);
        }

        if (this.showDataSourceCategorySubform) {
            this.appendDataSourceCategorySubformData(input);
        }

        if (this.showZoningCodeVersionSubform) {
            this.appendZCVersionSubformData(input);
        }

        if (this.isReconfiguration) {
            this.jobsService.updateProcess(this.process, input, true, true).subscribe(
                () => {
                    this.jobsService.checkJobStatus(this.process, true);
                },
                err => {
                    this.snackBar.open(
                        _.get(err, 'error.messages[0]', `Can not update Process ${this.process.id}`),
                        'OK',
                        {
                            verticalPosition: 'top',
                            horizontalPosition: 'center',
                            duration: 4000
                        }
                    );
                }
            );
        } else {
            this.jobsService.addJob(this.selectedJobType, input).subscribe(
                () => {},
                error => {
                    this.snackBar.open(error.error.messages[0], 'OK', {
                        verticalPosition: 'top',
                        horizontalPosition: 'center',
                        duration: 2000
                    });
                }
            );
        }
        this.dialogRef.close(true);
    }

    onNoClick() {
        event.stopPropagation();
        this.dialogRef.close(false);
    }

    private appendTypologySubformData(inputData: FormData): void {
        const typologyFormParams = TypologySubformComponent.getQueryParams(this.addJobForm.value['typologyForm']);
        if (typologyFormParams.zoningCodeId) {
            inputData.append('zoningCodeId', typologyFormParams.zoningCodeId);
        }
        if (typologyFormParams.selectedTypologies) {
            inputData.append('typologyIds', JSON.stringify(typologyFormParams.selectedTypologies.map(x => x.Id)));
        }
    }

    private appendListSubformData(inputData: FormData): void {
        const listFormParams = CalculateFolioSubformComponent.getQueryParams(
            this.addJobForm.value['listForm'],
            this.showZoningCodeSettings
        );
        if (listFormParams.file && !listFormParams.file.isDefault) {
            inputData.append('file', listFormParams.file);
            inputData.append(
                'dataSourceCategories',
                JSON.stringify(getDataSourceCategoriesArr(listFormParams.dataSourceCategories))
            );
        } else {
            if (listFormParams.title && listFormParams.file.isDefault) {
                const listParams = Array.isArray(listFormParams.value) ? listFormParams.value : [];
                inputData.append(listFormParams.title, JSON.stringify(listParams));
            }
        }
        inputData.append('needToRecalculate', listFormParams.needToRecalculate);
        if (listFormParams.place) {
            inputData.append('place', listFormParams.place);
        }
        if (listFormParams.zoningCodeId) {
            inputData.append('zoningCodeId', listFormParams.zoningCodeId);
        }
        inputData.append('maxThreadsCount', listFormParams.maxThreadsCount);
        if (listFormParams.title === ListType.FOLIOS) {
            inputData.append(
                'dataSourceCategories',
                JSON.stringify(getDataSourceCategoriesArr(listFormParams.dataSourceCategories))
            );
        }
    }

    private appendZoningCodeDropDownData(inputData): void {
        // tslint:disable-next-line:max-line-length
        const recalculateFormParams = RecalculateByStatusComponent.getQueryParams(
            this.addJobForm.value['recalculateForm']
        );
        if (recalculateFormParams) {
            inputData.append('zoningCodeId', recalculateFormParams.zoningCodeId);
            inputData.append('statusesToRecalculate', JSON.stringify(recalculateFormParams.statusesToRecalculate));
            inputData.append('maxThreadsCount', recalculateFormParams.maxThreadsCount);
        }
    }

    private appendZoningCodeSubformData(inputData): void {
        const zoningCodeParams = ZoningCodeSubformComponent.getQueryParams(this.addJobForm.value['zoningCodeForm']);
        if (_.get(zoningCodeParams, 'zoningCodeId')) {
            inputData.append('zoningCodeId', zoningCodeParams.zoningCodeId);
        }
    }

    // private appendImportNewIdsSubformData(inputData): void {
    //     const idsSourceUrlParams = ImportNewIdsSubformComponent.getQueryParams(
    //         this.addJobForm.value['idsSourceUrlForm']
    //     );
    //     if (idsSourceUrlParams) {
    //         inputData.append('idsSourceUrl', idsSourceUrlParams.idsSourceUrl);
    //     }
    // }

    private configureDialogWithProcess() {
        if (!this.isReconfiguration) {
            return;
        }

        this.selectedJobType = this.process.type;

        this.addJobForm.patchValue({
            name: this.process.name,
            startImmediately: true,
            syncSolrData: this.process.syncSolrData
        });

        setTimeout(() => {
            if (this.showListsSubform) {
                this.addJobForm.controls.listForm.patchValue({
                    needToRecalculate: !!this.process.needToRecalculate,
                    syncSolrData: !!this.process.syncSolrData,
                    maxThreadsCount: this.process.maxThreadsCount
                });
            }
        }, 200);
    }

    private appendFileChooserSubformData(inputData: FormData): void {
        const listFormParams = FileChooserSubformComponent.getQueryParams(this.addJobForm.value['fileChooserSubform']);
        if (listFormParams.file && !listFormParams.file.isDefault) {
            inputData.append('file', listFormParams.file);
        }
    }

    private appendDataSourceCategorySubformData(inputData: FormData): void {
        const dataSourceCategoryParams = DataSourceCategorySubformComponent.getQueryParams(
            this.addJobForm.value['dataSourceCategories']
        );
        inputData.append('dataSourceCategories', dataSourceCategoryParams);
    }

    private appendZCVersionSubformData(inputData: FormData): void {
        const zcvFormParams = ZcVersionSelectSubformComponent.getQueryParams(this.addJobForm.value['zcvForm']);
        if (zcvFormParams.selectedZCVersionId) {
            inputData.append('zcVersionId', zcvFormParams.selectedZCVersionId);
        }
    }

    onNeedToRecalculateChange(value) {
        if (value && !appSettings.skipSolrAUDataSyncForForcedMode) {
            this.addJobForm.patchValue({ syncSolrData: true });
            this.addJobForm.controls.syncSolrData.disable();
        } else {
            this.addJobForm.controls.syncSolrData.enable();
        }
    }
}
